export default {
  SAVE_CHANGES: ({ commit }) => {
    // Se usa para guardar en REDO UNDO
    commit("SET_CHANGES");
  }
}